// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3Jv0d","header":"Messages_header__3w71P"};